import { Modal, Icon, Button } from "@repo/ui";
import { useTranslation } from "react-i18next";
import styles from "./FlashcardImageLightbox.module.scss";

type FlashcardImageLightboxProps = {
  isOpen: boolean;
  imageUri: string;
  onClose: () => void;
};

export function FlashcardImageLightbox({
  isOpen,
  imageUri,
  onClose,
}: FlashcardImageLightboxProps) {
  const { t } = useTranslation("selflearn");

  return (
    <Modal
      isModalOpen={isOpen}
      onClose={onClose}
      showHeader={false}
      showFooter={false}
      overLayColor="rgba(0, 0, 0, 0.45)"
      justifyContent="center"
      alignItems="center"
      width="auto"
      height="auto"
      styles={{
        modal: {
          backgroundColor: "transparent",
          borderRadius: 0,
          overflow: "visible",
          boxShadow: "none",
          maxWidth: "100vw",
        },
        body: {
          flex: "0 0 auto",
          overflow: "visible",
        },
      }}
      body={
        <div className={styles.wrap}>
          <div className={styles.closeRow}>
            <Button
              variant="ghost"
              size="lg"
              onPress={onClose}
              aria-label={t("flashcards.a11y.closeImagePreview")}
              accessibilityLabel={t("flashcards.a11y.closeImagePreview")}
              leftIcon={
                <span className={styles.iconWrapper}>
                  <Icon name="close" size={24} color="#4E4B66" />
                </span>
              }
            />
          </div>
          <div className={styles.imageColumn}>
            <div key={imageUri} className={styles.imageStage}>
              <img className={styles.img} src={imageUri} alt="" />
            </div>
          </div>
        </div>
      }
    />
  );
}
